// extracted by mini-css-extract-plugin
module.exports = {"apli":"Materia_apli__2fqUY"};